import React from 'react';

function Oman(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1529_3036"
           style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="24"
      >
        <rect width="36" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_1529_3036)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H36V0H0Z"
          fill="#F50101"
        />
        <mask
          id="mask1_1529_3036"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_1529_3036)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V8H36V0H0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16V24H36V16H0Z"
            fill="#5EAA22"
          />
          <rect width="13.5" height="24" fill="#F50101" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1208 1.99693C12.1308 1.90797 12.0193 1.87093 11.9701 1.94569C11.5807 2.53696 10.5497 4.02577 8.82785 5.98612V5.06846C8.66718 4.91324 8.15496 4.49566 8.15496 4.49566V3.57934L9.0816 2.83395L7.80893 2L6.46754 2.83395L7.48144 3.57934V4.49566C7.48144 4.93506 6.86675 5.06846 6.86675 5.06846L6.7542 5.87682C5.15145 4.02685 4.16593 2.59367 3.76898 1.98546C3.71856 1.90822 3.60309 1.94852 3.61809 2.03953C3.73644 2.75737 4.10475 4.41961 5.15452 6.19647H4.87792V6.79385H5.17657C5.27791 7.00153 5.51062 7.14791 5.78276 7.15215C5.97287 7.41287 6.17904 7.67289 6.40261 7.92965C5.88807 7.88442 2.48935 7.62726 2.48935 8.7264C2.48935 9.3825 3.31609 9.72978 4.35293 9.90929C3.31017 10.7486 2.32586 11.5384 1.87175 11.9026C1.80171 11.9588 1.85058 12.0658 1.93828 12.0466C2.73882 11.871 4.87213 11.3214 6.90247 10.0902L6.96541 10.0902C7.53437 10.0902 7.9301 9.87085 8.20515 9.5739C10.2681 11.0707 12.603 11.7588 13.6057 12.003C13.7009 12.0262 13.7476 11.9006 13.6642 11.8491C12.8437 11.3428 10.9967 10.1262 9.10813 8.35959L9.15772 8.30797C9.54328 7.90353 9.87923 7.48752 10.172 7.0704C10.2945 7.00673 10.3921 6.90985 10.4487 6.79385H10.7474V6.19647H10.7253L10.7478 6.15671C10.7476 6.1591 10.7475 6.16151 10.7475 6.16395V7.49004C10.7475 7.53807 10.7864 7.577 10.8344 7.577H13.2285C13.2765 7.577 13.3154 7.53807 13.3154 7.49004V6.16395C13.3154 6.11593 13.2765 6.077 13.2285 6.077H10.8344C10.8152 6.077 10.7973 6.08328 10.7829 6.09391C11.7676 4.31988 12.0448 2.67674 12.1208 1.99693ZM2.30987 6.16395C2.30987 6.11593 2.3488 6.077 2.39682 6.077H4.79084C4.83887 6.077 4.8778 6.11593 4.8778 6.16395V7.49004C4.8778 7.53807 4.83887 7.577 4.79084 7.577H2.39682C2.3488 7.577 2.30987 7.53807 2.30987 7.49004V6.16395ZM6.34527 6.56087C6.34527 6.8281 6.0989 7.04474 5.795 7.04474C5.49109 7.04474 5.24473 6.8281 5.24473 6.56087C5.24473 6.29363 5.49109 6.077 5.795 6.077C6.0989 6.077 6.34527 6.29363 6.34527 6.56087ZM9.28002 6.56087C9.28002 6.8281 9.52638 7.04474 9.83029 7.04474C10.1342 7.04474 10.3806 6.8281 10.3806 6.56087C10.3806 6.29363 10.1342 6.077 9.83029 6.077C9.52638 6.077 9.28002 6.29363 9.28002 6.56087Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
    </svg>
  );
}

export default Oman;
